export function indexAuthoringTasksInSchedule(schedule) {
    let index = 1
    for (const [sort, task] of (schedule?.tasks ?? []).entries()) {
        task.$sort = sort
        if (task.isHeader) {
            task.taskId = task.headerTaskId ?? task.taskId ?? task.id ?? null
            continue
        }
        task.taskId ??= task.id
        task.$index = index++
    }
    return schedule
}
